import React, { ReactNode, useCallback } from "react";
import { CellRenderers } from "utils/tableUtils";

import GenericIntegrationTicketSystemListing from "../GenericIntegrationTicketSystemListing";
import {
  GenericIntegrationTicketDefaultValues,
  GenericIntegrationTicketSystemListingProps,
} from "../genericIntegrationTicketConstants";

function PagerDutyIntegrationListing({
  loginConfigList,
  loading,
  ...props
}: GenericIntegrationTicketSystemListingProps) {
  const getColumns = useCallback((columns) => {
    const updatedColumns = columns
      .filter((col: { dataIndex: string }) => {
        // PagerDuty does not have issueType field
        return col.dataIndex !== "issueType";
      })
      .map(
        (col: {
          dataIndex: string;
          title: ReactNode;
          render: () => ReactNode;
        }) => ({
          ...col,
          title: col.dataIndex === "projectKey" ? "Service" : col.title,
          render:
            col.dataIndex === "projectKey"
              ? (
                  projectKey: string,
                  record: GenericIntegrationTicketDefaultValues,
                ) => {
                  const projectKeyValue =
                    record.configMetaData?.projectMetaData?.name ?? projectKey;
                  return CellRenderers.VALUE_OR_NA(projectKeyValue);
                }
              : col.render,
        }),
      );
    return updatedColumns;
  }, []);
  return (
    <div>
      <GenericIntegrationTicketSystemListing
        loginConfigList={loginConfigList}
        loading={loading}
        getColumns={getColumns}
        {...props}
      />
    </div>
  );
}

export default PagerDutyIntegrationListing;
